import { SnapshotWeekly, Report } from "./reducer"
import { getReportWeeklyDetailForReward } from "../../../api"

export async function getReportsHelper(snapshots: any[]) {
    const mergedHashes = snapshots.flatMap(snapshot => {
        return (Object.entries(snapshot) as any).map(([weekNumber, { hash }]: [string, { hash: string }]) => ({
            weekNumber,
            hash,
        }))
    })

    // TODO: this won't work for staging because s3 data for staging are not ready yet
    const reports = await Promise.all(
        mergedHashes.map(({ weekNumber, hash }) => getReportWeeklyDetailForReward(weekNumber, hash)),
    )
    const ret = snapshots.reduce((acc, snapshot) => {
        acc.push(reports.splice(0, Object.values(snapshot).length))
        return acc
    }, [])
    return ret
}

export function getProcessedSnapshot(snapshot: any) {
    const processedSnapshot: Record<string, SnapshotWeekly> = {}
    let newLatestWeek = 0
    Object.entries(snapshot).forEach(([week, content]: [string, any]) => {
        const weekNumber = parseInt(week)
        if (weekNumber > newLatestWeek) {
            newLatestWeek = weekNumber
        }
        processedSnapshot[week] = {
            hash: content.hash,
            timestamp: content.redeemableUntil,
            weekNumber,
            totalRewardPerp: content.totalRewardPerp,
        }
    })
    return { processedSnapshot, newLatestWeek }
}

export function getProcessedReport(reports: any[]) {
    const newReports: Report[] = reports.map(report => {
        const newReport: Report = {}
        Object.entries(report).forEach(([address, content]: [string, any]) => {
            newReport[address] = content.totalRewardPerp
        })
        return newReport
    })
    return newReports
}
